import React, { useState } from "react";

const LeftImageHeroSection = ({
  label,
  description,
  firstButton,
  firstButtonClass,
  secondButton,
  secondButtonClass,
  firstButtonClick,
  secondButtonClick,
  quote,
  quoteAuthor,
  src="/people-image.png"
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <section className="relative bg-background-gradient text-white flex items-center min-h-screen py-10">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/HomeHeroBg.png"
          alt="Hero Background"
          className="w-full h-full object-cover opacity-70"
        />
      </div>

      {/* Overlay Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col-reverse md:flex-row items-center gap-10 md:gap-0">
        {/* Text Section */}
        <div className="w-full md:w-1/2 text-center md:text-left flex flex-col justify-center">
          <p className="text-sm text-gray-300 mb-2 flex items-center justify-center md:justify-start gap-3">
            <img src="/TitleShape.png" alt="TitleShape" className="w-5 h-5" />
            Welcome to OnTrack Careers
          </p>

          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight max-w-xl mx-auto md:mx-0">
            {label}
          </h1>

          <p className="mt-4 text-base sm:text-lg text-gray-300 max-w-xl mx-auto md:mx-0">
            {description}
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-center sm:justify-center md:justify-start gap-4">
            {firstButton && (
              <button
                onClick={firstButtonClick}
                className={`bg-custom-gradient text-white px-6 py-2 rounded-full hover:bg-blue-700 transition ${firstButtonClass}`}
              >
                {firstButton}
              </button>
            )}
            {secondButton && (
              <button
                onClick={secondButtonClick}
                className={`border border-white text-white px-6 py-2 rounded-full hover:bg-white hover:text-gray-900 transition ${secondButtonClass}`}
              >
                AI Job Impact Assessment
              </button>
            )}
          </div>

          {quote && (
            <div className="mt-8 text-gray-300 italic text-center md:text-left max-w-xl mx-auto md:mx-0">
              <p>"{quote}"</p>
              {quoteAuthor && (
                <p className="mt-2 text-sm font-semibold">- {quoteAuthor}</p>
              )}
            </div>
          )}
        </div>

        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-center items-center">
          <img
            src={src}
            alt="People working"
            className={`max-w-full h-auto transition-opacity duration-500 ${
              imageLoaded ? "opacity-100" : "opacity-0"
            }`}
            onLoad={() => setImageLoaded(true)}
          />
        </div>
      </div>
    </section>
  );
};

export default LeftImageHeroSection;
